import { Box } from '@dropbox/dig-foundations';
import React from 'react';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';

export function SignStepToolbarLayout({
  children,
}: React.PropsWithChildren<{}>) {
  return (
    <WhiteLabelThemeProvider mode="bright">
      <Box
        backgroundColor="Background Subtle"
        paddingLeft="Micro Small"
        paddingRight={{
          medium: 'Micro XLarge',
          small: 'Micro Large',
          xsmall: 'Micro Small',
        }}
        paddingY="Micro Medium"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        {children}
      </Box>
    </WhiteLabelThemeProvider>
  );
}
